<template>
  <modal :name="modalName" height="130px" width="355px">
    <div class="modal-dialog">
      <div class="paragraph paragraph-bold is-flex is-centered">{{ label }}</div>
      <div class="buttons">
        <button v-translate class="button is-accent-ghost" @click="closePopup();trackClose();">Cancel</button>
        <button v-translate class="button is-accent-default" @click="deleteItem">Delete</button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    label: String,
    modalName: String,
    index: Number,
    toastMessage: String
  },
  methods: {
    closePopup() {
      this.$modal.hide(this.modalName);
    },
    trackClose() {
      this.$emit('close');
    },
    showSuccessfulToast() {
      this.$toast.open({message: this.toastMessage, type: 'is-success'});
    },
    deleteItem() {
      this.$emit('delete', this.index);
      this.closePopup();
      this.showSuccessfulToast();
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  display: flex;
  flex-direction: column;
  padding: 20px;
}
.buttons {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
}
</style>
